import React, { useState } from "react";
import { Slider, Box, Typography } from "@mui/material";

const marks = Array.from({ length: 10 }, (_, i) => ({
  value: i + 1,
  label: `${i + 1}`,
  style:
    i === 0
      ? { transform: "translateX(10%)" }
      : i === 9
      ? { transform: "translateX(-10%)" }
      : {},
}));


export const SliderNumber = () => {
  const [value, setValue] = useState(5);

  return (
   <Box sx={{ width: "100%", px: 4 }}>

<Slider
  value={value}
  onChange={(e, newValue) => setValue(newValue)}
  step={1}
  marks={marks}
  min={1}
  max={10}
  valueLabelDisplay="auto"
  sx={{
    height: 10,
    borderRadius: 5,
    color: "transparent",
    background: "linear-gradient(to right, red, orange, yellow, green)",
    "& .MuiSlider-thumb": {
      height: 24,
      width: 24,
      backgroundColor: "#4CAF50",
      border: "2px solid white",
    },
    "& .MuiSlider-track": {
      background: "none",
    },
    "& .MuiSlider-rail": {
      opacity: 0,
    },
    "& .MuiSlider-mark": {
      color: "white",
    },
"& .MuiSlider-markLabel": {
  color: "white",
  top: "40%",
  transform: "translateY(-40%)",
  fontSize: "12px",
  lineHeight: 1,
  whiteSpace: "nowrap",
  overflow: "visible",
  textAlign: "center",
},



    "& .MuiSlider-valueLabel": {
      backgroundColor: "#4CAF50",
      color: "white",
      borderRadius: "50%",
    
    },
  }}
/>

    </Box>
  );
};


